import { ActionReducer } from '@ngrx/store';
import { CoreActionTypes } from '@appstore/*';
import { OverviewState } from './registration';
import { SanitizeStateForStorage } from '@shared/*';
import { ChecklistActionTypes, DepotActionTypes, ReportShiftActionTypes, TourActionTypes } from './actions';
import { LocalStorageUtil } from "../../shared/utilities/local-storage.util";

// todo save protocol photos in indexedDb as localstorage has limited space

/**
 * Meta-reducer which functions to save the data received from all overview actions to localstorage
 * for usage while loading the app in offline mode.
 * Photos uploaded in protocols while they are in progress are not stored at the moment.
 */
export function overviewOfflineSync(reducer: ActionReducer<OverviewState>): ActionReducer<OverviewState> {
    return (state, action) => {
        const reducedState = reducer(state, action);
        const storingActionTypes = [
            ...Object.values(TourActionTypes),
            ...Object.values(ReportShiftActionTypes),
            ...Object.values(ChecklistActionTypes),
            ...Object.values(DepotActionTypes)
        ];

        if (storingActionTypes.includes(action.type as (TourActionTypes | ReportShiftActionTypes | ChecklistActionTypes | DepotActionTypes ))) {
          LocalStorageUtil.setItemObject('overviewStore', SanitizeStateForStorage(reducedState));
        }
        return reducedState;
    };
}

/**
 * Meta-reducer which functions to repopulate the ngrx store with data when loading the app in offline mode
 * Photos uploaded in protocols while they are in progress are not repopulated at the moment.
 */
export function overviewOfflineHydrate(reducer: ActionReducer<OverviewState>): ActionReducer<OverviewState> {
    return (state, action) => {
        let reducedState = reducer(state, action);
        if (action.type === CoreActionTypes.OFFLINE_HYDRATE_STORE) {

            const cachedStore = LocalStorageUtil.getItem('overviewStore');
            if (cachedStore) {
                reducedState = {
                    ...reducedState,
                    ...JSON.parse(cachedStore),
                };
            }
        }
        return reducedState;
    };
}
